import React, { FC, createContext, useReducer, ReactNode } from "react";
import { ITermoContext } from "./Interfaces/ITermoContext";
import { TermoEffects } from "./Termo.Effect";

export const TermoContext = createContext<ITermoContext>({} as ITermoContext);

const TermoProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const effects = TermoEffects();

  return (
    <TermoContext.Provider
      value={{
        effects: effects,
      }}
    >
      {children}
    </TermoContext.Provider>
  );
};

export default TermoProvider;
